<script setup lang="ts">
defineProps({
  useDialog: {
    type: Boolean, // TODO: use different color for dark on dialogs - is not visibile
  },
});
</script>
<template>
  <divider
    class="p-0"
    :ptOptions="{ mergeSections: true, mergeProps: true }"
    :pt="{
      root: ['!my-4 before:border-t before:border-surface-200 before:dark:!border-gray-800'],
    }"
  />
</template>
